/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LinerInspectionReportInclusions = {
    None: 'None',
    /**
    * Condition Map Pre-shut
    */
    ConditionMapPreShut: 'ConditionMapPreShut',
    /**
    * Condition Map Actual
    */
    ConditionMapActual: 'ConditionMapActual',
    /**
    * Condition Map Post-shut
    */
    ConditionMapPostShut: 'ConditionMapPostShut',
    /**
    * Changeout Map Planned
    */
    ChangeoutMapPlanned: 'ChangeoutMapPlanned',
    /**
    * Changeout Map Actual
    */
    ChangeoutMapActual: 'ChangeoutMapActual',
    /**
    * 360 Panoramic Image
    */
    PanoramicImage360: 'PanoramicImage360',
    /**
    * Liner List
    */
    LinerList: 'LinerList',
    /**
    * Inspection History
    */
    InspectionHistory: 'InspectionHistory'
} as const;
export type LinerInspectionReportInclusions = typeof LinerInspectionReportInclusions[keyof typeof LinerInspectionReportInclusions];


export function instanceOfLinerInspectionReportInclusions(value: any): boolean {
    for (const key in LinerInspectionReportInclusions) {
        if (Object.prototype.hasOwnProperty.call(LinerInspectionReportInclusions, key)) {
            if (LinerInspectionReportInclusions[key as keyof typeof LinerInspectionReportInclusions] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LinerInspectionReportInclusionsFromJSON(json: any): LinerInspectionReportInclusions {
    return LinerInspectionReportInclusionsFromJSONTyped(json, false);
}

export function LinerInspectionReportInclusionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinerInspectionReportInclusions {
    return json as LinerInspectionReportInclusions;
}

export function LinerInspectionReportInclusionsToJSON(value?: LinerInspectionReportInclusions | null): any {
    return value as any;
}

export function LinerInspectionReportInclusionsToJSONTyped(value: any, ignoreDiscriminator: boolean): LinerInspectionReportInclusions {
    return value as LinerInspectionReportInclusions;
}

